module.exports = __webpack_public_path__ + "static/media/img_11.b6adc9d8.jpg";